<template>
  <div class="admin-login-page">
    <div class="admin-login-card">
      <div class="auth_brand">
        <a href="javascript:void(0);">
          <img src="/appimages/logo/Zoopup-02_128x128.png" alt="ZoopUp" />
        </a>
      </div>

      <p class="admin-login-eyebrow">ZoopUp Admin</p>
      <p class="lead">Admin sign-in</p>
      <p class="sso-copy">Use your Microsoft work account to access the ZoopUp admin panel.</p>

      <div v-if="errorMessage" class="sso-error" role="alert">
        {{ errorMessage }}
      </div>

      <div class="sso-actions">
        <a class="sso-btn" :href="microsoftLoginUrl">
          <span class="sso-btn__icon" aria-hidden="true">
            <svg viewBox="0 0 21 21" width="18" height="18">
              <rect x="1" y="1" width="9" height="9" fill="#f25022" />
              <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
              <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
              <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
            </svg>
          </span>
          Sign in with Microsoft
        </a>
      </div>

      <p class="sso-note">Username and password login is disabled for admins.</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    ssoError: {
      type: String,
      default: '',
    },
    microsoftLoginUrl: {
      type: String,
      default: '/admin/auth/microsoft',
    },
  },
  data() {
    return {
      errorMessage: this.ssoError || '',
    };
  },
  created() {
    this.$store.commit('setUpdateUser', false);
  },
};
</script>

<style scoped>
.admin-login-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px 16px;
  background:
    radial-gradient(ellipse 80% 50% at 50% -20%, rgba(5, 165, 251, 0.18), transparent 55%), #f4f7fa;
  font-family:
    Inter,
    system-ui,
    -apple-system,
    sans-serif;
}

.admin-login-card {
  width: 100%;
  max-width: 420px;
  background: #fff;
  border: 1px solid #f1f5f9;
  border-radius: 24px;
  box-shadow: 0 20px 40px -12px rgba(0, 59, 88, 0.18);
  padding: 36px 32px 28px;
  text-align: center;
}

.auth_brand img {
  width: 56px;
  height: 56px;
}

.admin-login-eyebrow {
  margin: 12px 0 0;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #05a5fb;
}

.lead {
  margin: 8px 0 0;
  font-size: 1.35rem;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: #0f172a;
}

.sso-copy,
.sso-note {
  margin: 8px 0 0;
  color: #64748b;
  font-size: 0.92rem;
  line-height: 1.5;
}

.sso-note {
  margin-top: 16px;
  font-size: 0.82rem;
}

.sso-error {
  margin: 16px 0 0;
  padding: 12px 14px;
  border-radius: 12px;
  background: rgba(220, 38, 38, 0.08);
  color: #b91c1c;
  font-size: 0.88rem;
  font-weight: 600;
}

.sso-actions {
  padding: 22px 0 8px;
}

.sso-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  min-height: 46px;
  border-radius: 6px;
  background: linear-gradient(135deg, #05a5fb, #037cc3);
  color: #fff !important;
  font-weight: 600;
  text-decoration: none;
  box-shadow: 0 8px 24px -4px rgba(5, 165, 251, 0.35);
}

.sso-btn__icon {
  display: inline-flex;
  width: 22px;
  height: 22px;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  background: #fff;
}
</style>
